import { createApp } from 'vue'
import { createPinia } from 'pinia'

import VlUiVueComponents from '@govflanders/vl-ui-design-system-vue3';
import globalComponents from '@/plugins/global-components-plugin';
import validations from './plugins/validations-plugin';
import dayjs from './plugins/dayjs-plugin';

import App from './app/app.vue';
import routerPlugin from '@/router/router';

const app = createApp(App)

app.use(createPinia())
app.use(routerPlugin)
app.use(VlUiVueComponents);
app.use(globalComponents);
app.use(validations);
app.use(dayjs);

app.mount('#app')
